import { Component } from '@angular/core'

@Component({
  selector: 'kdgh-postal-address-form',
  templateUrl: './postal-address-form.component.html',
  styleUrls: ['./postal-address-form.component.scss'],
})
export class PostalAddressFormComponent {}
